import { DateFieldUI } from '@axo/form/feature/form-input/DateField/DateFieldUI';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { loan_application, Residence } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../utils/format';
import { useESkatVisibility } from '../../../ESkat';
import type { Step4Data } from '../../FormData.dk.types';
import { housingOptions, radioOptions } from '../../config/globals';
import { requiredField } from '../shared-config';
import { rentCostMonthlyFieldOptions } from './config/rentCostMonthly';

export const HousingFormGroup = () => {
  const { t } = useTranslation();

  const [housingTypeFilledByESkat, livedSinceFilledByESkat] =
    useESkatVisibility(['HousingType', 'LivedAtAddressSince']);

  const housingType = useWatch({
    name: 'LoanApplication/HousingType',
  }) as loan_application.Residence;

  const askHousingFields = !!housingType;

  const askRentCost = [
    Residence.CooperativeApartment,
    Residence.Rental,
  ].includes(housingType);

  const currentYear = new Date().getFullYear();

  return (
    <>
      {!housingTypeFilledByESkat && (
        <DropdownFieldUI<Step4Data>
          name="LoanApplication/HousingType"
          label={t('HousingType.label')}
          placeholder={t('placeholder')}
          data-testid="housing-dropdown"
          options={housingOptions}
          registerOptions={requiredField}
        />
      )}

      {askHousingFields && (
        <>
          {!livedSinceFilledByESkat && (
            <DateFieldUI<Step4Data>
              name="Person/LivedAtAddressSince"
              label={t('LivedAtAddressSince.label')}
              data-testid="lived-at-address-since-dropdown"
              minYearSuffix={t('LivedAtAddressSince.year_suffix')}
              yearPlaceholder={t('placeholder')}
              i18n="da-DK"
              showYearOnly={true}
              minYear={currentYear - (currentYear - 1950)}
              maxYear={currentYear}
              disableDatesInFuture
              latestYearAtTop={true}
              rules={requiredField}
            />
          )}

          {askRentCost && (
            <NumberFieldUI<Step4Data>
              name="LoanApplication/RentCostMonthly"
              label={t('RentCostMonthly.label')}
              data-testid="rent-cost-input"
              format={formatSpacedNumber}
              suffix={t('suffix.currency')}
              {...rentCostMonthlyFieldOptions}
            />
          )}
        </>
      )}

      <RadioFieldUI<Step4Data>
        name="LoanApplication/OwnsHolidayHome"
        label={t('OwnsHolidayHome.label')}
        data-testid="holiday-house-radio"
        radioStyle="button"
        options={radioOptions}
        registerOptions={requiredField}
      />
    </>
  );
};
